export const ANNOUNCE_STATUS_LIST_MUTATION = "ANNOUNCE_STATUS_LIST_MUTATION";
